
const customerIntTypeApprovedStates = {
  'ConnectEd':['home.assign','home.manage'],
  'Matrix':['home.assign']
};

const CUSTOMER_ALLOWED_STATES = {

  curriedStateValidation: function(stateName){
    return function(){
      let integrationTypes= Object.keys(customerIntTypeApprovedStates);
      let approvedIntegrations=[];
      integrationTypes.forEach(function(integration){
        let approvedStates=customerIntTypeApprovedStates[integration];
        if(approvedStates.indexOf(stateName)>=0){
          approvedIntegrations.push(integration);
        }
      });
      return approvedIntegrations;
    };
  }
};

export default CUSTOMER_ALLOWED_STATES;



// WEBPACK FOOTER //
// ./app/models/customerAllowedStates.js